import { Dialog, Box, Typography, TextField } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { reasonForMismatchModalStyles } from './ReasonForMismatchModal.styles';
import { NAME_MISMATCH_REASON_OPTIONS } from 'constants/nameMisMatchReasonOptions';
import { useTranslation } from "react-i18next";

const svgPaths = {
  p33c4cc0: "M10 5C9.0111 5 8.0444 5.29324 7.22215 5.84265C6.39991 6.39206 5.75904 7.17295 5.38061 8.08658C5.00217 9.00021 4.90315 10.0055 5.09608 10.9754C5.289 11.9454 5.76521 12.8363 6.46447 13.5355C7.16373 14.2348 8.05465 14.711 9.02455 14.9039C9.99446 15.0968 10.9998 14.9978 11.9134 14.6194C12.8271 14.241 13.6079 13.6001 14.1574 12.7778C14.7068 11.9556 15 10.9889 15 10C14.9995 8.67408 14.4725 7.40263 13.5349 6.46506C12.5974 5.5275 11.3259 5.00054 10 5ZM10 0C8.02219 0 6.08879 0.586489 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17316C0.00433278 8.00042 -0.1937 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8078C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C19.9989 7.34816 18.945 4.80525 17.0699 2.93012C15.1947 1.05499 12.6518 0.00107974 10 0ZM10 18.0006C8.41763 18.0006 6.8708 17.5314 5.5551 16.6523C4.23941 15.7731 3.21395 14.5236 2.6084 13.0617C2.00286 11.5998 1.84442 9.99112 2.15312 8.43916C2.46183 6.88719 3.22381 5.46162 4.34272 4.34271C5.46162 3.22381 6.88719 2.46182 8.43916 2.15312C9.99113 1.84441 11.5998 2.00285 13.0617 2.6084C14.5236 3.21395 15.7731 4.2394 16.6523 5.5551C17.5314 6.87079 18.0006 8.41763 18.0006 10C18.001 11.0508 17.7943 12.0913 17.3924 13.0622C16.9905 14.033 16.4012 14.9152 15.6582 15.6582C14.9152 16.4012 14.033 16.9905 13.0622 17.3924C12.0913 17.7943 11.0508 18.001 10 18.0006Z",
  p35c7df00: "M15.6679 0.354387C15.4408 0.127468 15.1329 0 14.8119 0C14.4909 0 14.183 0.127468 13.9559 0.354387L8.0229 6.28739L2.0899 0.354387C1.86087 0.137295 1.55615 0.0181774 1.24061 0.0223978C0.925068 0.0266181 0.623638 0.153842 0.400498 0.376983C0.177357 0.600124 0.0501326 0.901553 0.0459122 1.21709C0.0416919 1.53263 0.160809 1.83736 0.377902 2.06639L6.3099 7.99939L0.377902 13.9334C0.260504 14.0447 0.16659 14.1783 0.101703 14.3265C0.0368164 14.4747 0.0022716 14.6344 0.000108311 14.7961C-0.00205498 14.9578 0.028207 15.1184 0.089108 15.2682C0.150009 15.4181 0.240314 15.5542 0.354694 15.6686C0.469073 15.783 0.605208 15.8733 0.755062 15.9342C0.904917 15.9951 1.06545 16.0253 1.2272 16.0232C1.38894 16.021 1.54861 15.9865 1.69678 15.9216C1.84495 15.8567 1.97862 15.7628 2.0899 15.6454L8.0229 9.71239L13.9549 15.6454C14.1839 15.8625 14.4887 15.9816 14.8042 15.9774C15.1197 15.9732 15.4212 15.8459 15.6443 15.6228C15.8674 15.3997 15.9947 15.0982 15.9989 14.7827C16.0031 14.4671 15.884 14.1624 15.6669 13.9334L9.7359 7.99939L15.6679 2.06639C15.8948 1.83931 16.0223 1.53141 16.0223 1.21039C16.0223 0.88936 15.8948 0.581469 15.6679 0.354387Z",
  p3dcb9200: "M10 0C8.02219 0 6.08879 0.586489 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17316C0.00433278 8.00042 -0.1937 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8078C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C19.9989 7.34816 18.945 4.80525 17.0699 2.93012C15.1947 1.05499 12.6518 0.00107974 10 0ZM10 18.0006C8.41763 18.0006 6.8708 17.5314 5.5551 16.6523C4.23941 15.7731 3.21395 14.5236 2.6084 13.0617C2.00286 11.5998 1.84442 9.99112 2.15312 8.43916C2.46183 6.88719 3.22381 5.46162 4.34272 4.34271C5.46162 3.22381 6.88719 2.46182 8.43916 2.15312C9.99113 1.84441 11.5998 2.00285 13.0617 2.6084C14.5236 3.21395 15.7731 4.2394 16.6523 5.5551C17.5314 6.87079 18.0006 8.41763 18.0006 10C18.001 11.0508 17.7943 12.0913 17.3924 13.0622C16.9905 14.033 16.4012 14.9152 15.6582 15.6582C14.9152 16.4012 14.033 16.9905 13.0622 17.3924C12.0913 17.7943 11.0508 18.001 10 18.0006Z",
}

interface ReasonForMismatchModalProps {
  open: boolean;
  onClose: () => void;
  selectedReason: string;
  onSelect: (reason: string, customReason?: string) => void;
}

export function ReasonForMismatchModal({ open, onClose, selectedReason: initialSelectedReason, onSelect }: ReasonForMismatchModalProps) {
  const { t } = useTranslation();
  const [tempSelection, setTempSelection] = useState<string>(initialSelectedReason);
  const [customReason, setCustomReason] = useState<string>('');

  useEffect(() => {
    if (open) {
      setTempSelection(initialSelectedReason);
      setCustomReason('');
    }
  }, [open, initialSelectedReason]);

  const reasons = NAME_MISMATCH_REASON_OPTIONS;

  const handleReasonClick = (reason: string) => {
    setTempSelection(reason);
    if (reason !== 'Others') {
      // Automatically save and close for non-Others options
      onSelect(reason);
      onClose();
    }
  };

  const handleCustomReasonChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCustomReason(e.target.value);
  };

  const handleCustomReasonBlur = () => {
    // Save when user finishes typing in custom reason
    if (tempSelection === 'Others' && customReason.trim()) {
      onSelect(tempSelection, customReason);
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={onClose} PaperProps={{ sx: reasonForMismatchModalStyles.dialogPaper, }} >
      <Box sx={reasonForMismatchModalStyles.root}>
        <Box sx={reasonForMismatchModalStyles.titleRow}>
          <Typography sx={reasonForMismatchModalStyles.titleText}>
             {t("reason_options", { defaultValue: "Reason for Name Mismatch" })}
          </Typography>
          <Box onClick={onClose} sx={reasonForMismatchModalStyles.closeButton}>
            <svg fill="none" viewBox="0 0 16.0223 16.0233" width="16" height="16">
              <path d={svgPaths.p35c7df00} fill="#999999" />
            </svg>
          </Box>
        </Box>
        <Box sx={reasonForMismatchModalStyles.optionsWrap}>
          {reasons.map((reason, index) => (
            <Box key={reason}>
              <Box onClick={() => handleReasonClick(reason)} sx={reasonForMismatchModalStyles.optionRow} >
                <Box sx={reasonForMismatchModalStyles.radioOuter}>
                  <Box sx={reasonForMismatchModalStyles.radioInner}>
                    <svg fill="none" viewBox="0 0 20 20" width="20" height="20">
                      <path
                        d={tempSelection === reason ? svgPaths.p33c4cc0 : svgPaths.p3dcb9200}
                        fill={tempSelection === reason ? '#007CBF' : '#666666'}
                      />
                    </svg>
                  </Box>
                </Box>
                <Typography sx={reasonForMismatchModalStyles.optionText}>
                  {reason}
                </Typography>
              </Box>

              {tempSelection === 'Others' && reason === 'Others' && (
                <Box sx={reasonForMismatchModalStyles.customReasonWrap}>
                  <TextField
                    fullWidth
                    placeholder="Please specify the reason"
                    value={customReason}
                    onChange={handleCustomReasonChange}
                    onBlur={handleCustomReasonBlur}
                    autoFocus
                    sx={reasonForMismatchModalStyles.customReasonInput}
                  />
                </Box>
              )}

              {index < reasons.length - 1 && (
                <Box sx={reasonForMismatchModalStyles.divider} />
              )}
            </Box>
          ))}
        </Box>
      </Box>
    </Dialog>
  );
}